import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DayTab from './DayTab';
import CatTab from './CatTab';
import { useDispatch, useSelector } from 'react-redux';
// import { selectEventType } from '../actions/eventType'
import Button from '@mui/material/Button';
import MapIcon from '@mui/icons-material/Map';
import { toggleMap } from '../actions/map';
var Header = function Header() {
  var events = useSelector(function (state) {
    return state.events;
  });
  var mapToggled = useSelector(function (state) {
    return state.mapToggled;
  });
  // const eventType = useSelector( state => state.eventType );
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    eventCatsFiltered = _useState2[0],
    setEventCatsFiltered = _useState2[1];
  var dispatch = useDispatch();
  var navigate = useNavigate();
  var params = useParams();
  useEffect(function () {
    if (!events) return;
    if (!params.cat && params.type !== 'virtual') {
      var selectedType = params.type ? params.type : 'one-time';
      var selectedCat = selectedType === 'one-time' ? eventIntros[0] : eventCatsFiltered[0].slug;
      // navigate({ pathname: `/${selectedType}/${selectedCat}/`})
      navigate({
        pathname: "/virtual/"
      });
    }
    setEventCatsFiltered(Object.keys(eventCats).length && events ? eventCats.filter(function (eventCat) {
      return eventCat.slug in events && events[eventCat.slug].filter(function (event) {
        return event.durational && !event.virtual;
      }).length;
    }) : []);
  }, [events]);
  var hasEventsByday = function hasEventsByday(day) {
    var dayData = new Date(day);
    var fullYear = dayData.getFullYear();
    var fullMonth = dayData.getMonth() + 1 < 10 ? "0".concat(dayData.getMonth() + 1) : dayData.getMonth() + 1;
    var fullDate = dayData.getDate() < 10 ? "0".concat(dayData.getDate()) : dayData.getDate();
    var dateString = "".concat(fullYear, "-").concat(fullMonth, "-").concat(fullDate);
    var eventsByDate = events[dateString];
    if ((eventsByDate === null || eventsByDate === void 0 ? void 0 : eventsByDate.length) > 0) {
      return true;
    } else {
      return false;
    }
  };

  // const eventDaysFiltered = eventIntros.length && events
  // ? eventIntros.filter( event => {
  //     return hasEventsByDay(event)
  //   })
  // : []

  // useEffect(() => {
  //   if (location.search.includes('?eventType') && events) {
  //     const urlSearchParams = new URLSearchParams(location.search);
  //     const intro = urlSearchParams.get('intro') || false
  //     if (eventType !== eventType) {
  //       if (eventType !== 'one-time') {          
  //         let index = eventCats.findIndex(it => {
  //           return it.slug == eventType;
  //         })
  //         if ( index < 0) {
  //           let eventCat = eventCats.find( eventCat => {
  //             return eventCat.count > 0 && events[eventCat.slug]?.length > 0
  //           });
  //           navigate({
  //             to: `/${eventCat ? eventCat.slug : 'on-going'}`,
  //           });
  //         }
  //       }

  //       changeEventType(eventType, intro);
  //     }
  //   }
  // }, [events])

  return /*#__PURE__*/React.createElement("div", {
    id: "events-header"
  }, nycjwEventSettings.watch_live_link && /*#__PURE__*/React.createElement("div", {
    className: "watch-live-link text-centered"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn watch-live",
    target: nycjwEventSettings.watch_live_link.target,
    href: nycjwEventSettings.watch_live_link.url
  }, /*#__PURE__*/React.createElement("span", null, nycjwEventSettings.watch_live_link.title))), /*#__PURE__*/React.createElement("div", {
    className: "sub-nav sub-nav-events",
    style: {
      'display': 'none'
    }
  }, /*#__PURE__*/React.createElement("ul", {
    className: "menu"
  }, eventsSubMenu.map(function (menuItem) {
    return /*#__PURE__*/React.createElement("li", {
      key: "menu-".concat(menuItem.ID)
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      size: "small",
      sx: {
        color: '#000',
        fontSize: '1.2rem',
        fontFamily: 'Bebas Neue',
        background: 'transparent',
        border: 'none',
        '&:hover, &.Mui-focusVisible': {
          background: 'transparent'
        }
      },
      onClick: function onClick() {
        return window.location.replace(menuItem.url);
      }
    }, menuItem.title));
  }), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    endIcon: /*#__PURE__*/React.createElement(MapIcon, null),
    size: "small",
    disabled: params.type === 'virtual',
    sx: {
      color: '#000',
      fontSize: '1.2rem',
      fontFamily: 'Bebas Neue',
      background: 'transparent',
      border: 'none',
      '&:hover, &.Mui-focusVisible': {
        background: 'transparent'
      }
    },
    onClick: function onClick() {
      return dispatch(toggleMap(!mapToggled));
    }
  }, "Map View")))), /*#__PURE__*/React.createElement("div", {
    id: "events-sub-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-type-menu-wrapper".concat(events ? '' : ' disabled')
  }, eventIntros.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "event-type-menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-type-button-wrapper"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "large",
    className: "event-type"
    //startIcon={<DevicesIcon sx={{ color: 'black' }} />}
    ,
    sx: {
      color: '#000',
      background: params.type === 'virtual' ? '#FEF200' : '#fff',
      border: '3px solid black',
      borderRadius: '6px',
      '&:hover, &.Mui-focusVisible': {
        background: params.type === 'virtual' ? '#FEF200' : 'rgba(0,0,0,.05)',
        borderColor: 'black'
      }
    },
    onClick: function onClick() {
      return navigate({
        pathname: "/virtual/"
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-content"
  }, "Virtual Events"))), /*#__PURE__*/React.createElement("div", {
    className: "event-type-button-wrapper"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "large",
    className: "event-type"
    // startIcon={<TodayIcon sx={{ color: 'black' }} />}
    ,
    sx: {
      color: '#000',
      background: params.type === 'one-time' || params.type === undefined ? '#FEF200' : '#fff',
      border: '3px solid black',
      borderRadius: '6px',
      '&:hover, &.Mui-focusVisible': {
        background: params.type === 'one-time' || params.type === undefined ? '#FEF200' : 'rgba(0,0,0,.05)',
        borderColor: 'black'
      }
    },
    onClick: function onClick() {
      return navigate({
        pathname: "/one-time/".concat(eventIntros[0], "/")
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-content"
  }, "one-time Events"))), /*#__PURE__*/React.createElement("div", {
    className: "event-type-button-wrapper"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "large",
    className: "event-type"
    //startIcon={<CalendarMonthIcon sx={{ color: 'black' }} />}
    ,
    sx: {
      color: '#000',
      background: params.type === 'on-going' ? '#FEF200' : '#fff',
      border: '3px solid black',
      borderRadius: '6px',
      '&:hover, &.Mui-focusVisible': {
        background: params.type === 'on-going' ? '#FEF200' : 'rgba(0,0,0,.05)',
        borderColor: 'black'
      }
    },
    onClick: function onClick() {
      return navigate({
        pathname: "/on-going/".concat(eventCatsFiltered[0].slug, "/")
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-content"
  }, "on-going Events")))))), /*#__PURE__*/React.createElement("section", {
    id: "events-tabs-wrapper"
  }, params.type === 'virtual' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    id: "virtual-events-section"
  }, /*#__PURE__*/React.createElement("div", {
    id: "virtual-header"
  }, /*#__PURE__*/React.createElement("h2", null, "Virtual Events"))), /*#__PURE__*/React.createElement("div", {
    id: "events-header-tabs",
    style: {
      'display': 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      'pointerEvents': 'none'
    },
    onClick: function onClick() {
      return navigate({
        pathname: "/virtual"
      });
    },
    className: "header-tab ".concat(params.type === 'virtual' && params.cat !== 'instagram' ? ' active' : '')
  }, /*#__PURE__*/React.createElement("h3", null, "Virtual Events")), /*#__PURE__*/React.createElement("div", {
    style: {
      'display': 'none'
    },
    onClick: function onClick() {
      return navigate({
        pathname: "/virtual/instagram"
      });
    },
    className: "header-tab ".concat(params.cat === 'instagram' ? ' active' : '')
  }, /*#__PURE__*/React.createElement("h3", null, "Instagram Events")))), (params.type === 'one-time' || params.type === undefined) && /*#__PURE__*/React.createElement("div", {
    id: "events-header-tabs"
  }, eventIntros.length > 1 && eventIntros.map(function (day) {
    return /*#__PURE__*/React.createElement(DayTab, {
      key: day,
      day: day
    });
  })), params.type === 'on-going' && /*#__PURE__*/React.createElement("div", {
    id: "events-header-tabs"
  }, events && Object.keys(eventCatsFiltered).length > 1 && Object.keys(eventCatsFiltered).map(function (cat) {
    return /*#__PURE__*/React.createElement(CatTab, {
      key: eventCatsFiltered[cat].slug,
      cat: eventCatsFiltered[cat]
    });
  }))), /*#__PURE__*/React.createElement("div", {
    id: "events-tab-select-wrapper"
  }, params.type === 'virtual' &&
  /*#__PURE__*/
  // Temporarily hide this selector after the event week is over
  React.createElement("div", null, /*#__PURE__*/React.createElement("select", {
    id: "events-tab-select",
    value: "/".concat(params.type).concat(params.cat === 'instagram' ? '/instagram' : ''),
    onChange: function onChange(e) {
      return navigate({
        pathname: e.target.value
      });
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: "/virtual",
    key: "cat-virtual"
  }, "Virtual Events"), /*#__PURE__*/React.createElement("option", {
    value: "/virtual/instagram",
    key: "cat-instagram"
  }, "Instagram Events"))), params.type === 'one-time' && /*#__PURE__*/React.createElement("select", {
    id: "events-tab-select",
    value: params.cat,
    onChange: function onChange(e) {
      return navigate({
        pathname: "/".concat(params.type ? params.type : 'one-time', "/").concat(e.target.value, "/")
      });
    }
  }, eventIntros.map(function (day) {
    return /*#__PURE__*/React.createElement(DayTab, {
      option: true,
      key: day,
      day: day
    });
  })), params.type === 'on-going' && /*#__PURE__*/React.createElement("select", {
    id: "events-tab-select",
    value: params.cat,
    onChange: function onChange(e) {
      return navigate({
        pathname: "/".concat(params.type, "/").concat(e.target.value, "/")
      });
    }
  }, Object.keys(eventCatsFiltered).map(function (cat) {
    return /*#__PURE__*/React.createElement(CatTab, {
      option: true,
      key: eventCatsFiltered[cat].slug,
      cat: eventCatsFiltered[cat],
      name: eventCatsFiltered[cat]
    });
  }))));
};
Header.propTypes = {};
export default Header;